<div id="layout-wrapper">
  <!-- Top Bar -->
  <app-header (selectedTabEvent)="onClickEvent($event)"></app-header>
  <!-- Side Bar -->
  <app-menu (menuClickEvent)="onClickEvent($event)" [selectedMenu]="selectedMenu"></app-menu>
  <div class="main-content">
    <div class="page-content">
      <!--<div class="container-fluid" [hidden]="!mainView">
        <router-outlet></router-outlet>
      </div>-->
      <div class="container-fluid p-0">
        <app-main-layout-template [selectedComponent]="selectedMenu?.componentId"></app-main-layout-template>
        <app-tickets [hidden]="'ticketEdit' !== selectedMenu?.componentId"></app-tickets>
      </div>
    </div>
  </div>
</div>

<ngx-spinner [fullScreen]="true" name="main-spinner" size="default" type="line-spin-clockwise-fade"></ngx-spinner>
